/* eslint-disable no-dupe-keys */
export default {
  evcs_station: {
    name: '第三方电站',
    // 属性（一般与对象内容匹配）
    prop: {
      station_name: '站名',
      cover_picture: '图片',
      station_id: '站ID',
      address: '地址',
      evcs_operator: '平台商',
      station_type: '站类型',
      station_status: '状态',
      electricity_fee: '电费',
      service_fee: '服务费',
      park_fee: '停车费',
      evcs_equipments_count: '设备数',
      payment: '支付',
      park_info: '车位描述',
      construction: '建筑区域',
      site_guide: '站点指引',
      station_lng: '经度',
      station_lat: '纬度',
      park_nums: '车位数量',
      station_tel: '站点电话',
      service_tel: '服务电话',
      area_code: '省市辖区编码',
      equipment_owner_id: '设备运营商ID',
      support_order: '支持预约',
      created_at: '创建时间',
      updated_at: '更新时间',
      time_range: '时间区间',
      price: '单价',
      fee: '价格',
      current_total_price: '当前价格',
      prices_range: '价格区间',
      province: '省份',
      city: '城市',
      constructions: '建筑区域'
    },
    // Enum的属性
    station_types: {
      public_station: '公共',
      individual: '个人',
      bus: '公交专用',
      sanitation: '环卫专用',
      logistics: '物流专用',
      taxi: '出租车专用',
      other_type: '其他'
    },
    station_statuses: {
      all: '全部',
      unknown: '未知',
      constructing: '建设中',
      maintaining: '维护中',
      available: '正常使用',
      unavailable: '关闭下线'
    },
    constructions: {
      residential_areas: '居民区',
      public_institutions: '公共机构',
      enterprises_and_institutions: '企事业单位',
      office_buildings: '写字楼',
      industrial_park: '工业园区',
      transportation_junction: '交通枢纽',
      recreational_facilities: '大型文体设施',
      urban_green_space: '城市绿地',
      parking_lot: '大型建筑配建停车场',
      roadside_parking: '路边停车位',
      service_ares: '城际高速服务区',
      others: '其他'
    },
    support_orders: {
      not_support: '不支持预约',
      support: '支持预约'
    },
    // Boolean的属性
    // 占位提示
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      equipment: '设备',
      evcs_connector: '设备接口',
      order: '订单'
    },
    group_titles: {
      base: '基本信息',
      location: '位置',
      fee: '费用',
      operation: '运营',
      picture: '图片'
    },

    // 旧的国际化
    charge_over_reason_list: {
      user_stop: '用户手动停止充电',
      platform_stop: '客户归属地运营商平台停止充电',
      bms_stop: 'BMS停止充电',
      equip_fault_stop: '充电机设备故障',
      disconnect_stop: '链接器断开',
      other_stop: '未知'
    },
    order_menu_status: {
      starting: '启动中',
      charging: '充电中',
      stopping: '停止中',
      finished: '已结束',
      unavailable: '未知'
    },
    equipments_menu_status: {
      available: '空闲',
      off_network: '离网',
      occupation: '占用',
      fault: '故障',
      unknown: '未知'
    },
    equipments_connector_status: {
      available: '空闲',
      offline: '离网',
      ready: '占用(未充电)',
      charging: '占用(充电中)',
      reserved: '占用(预约锁定)',
      fault: '故障',
      unknown: '未知'
    },
    equipments_lock_status: {
      unavailable: '未知',
      unlocked: '空闲',
      locked: '占用'
    },
    equipments_park_status: {
      unavailable: '未知',
      available: '已解锁',
      occupy: '已上锁'
    },
    equipment_type: {
      dc: '直流设备',
      ac: '交流设备',
      wireless: '无线设备',
      other: '其他'
    },
    connector_type: {
      household_socket: '家用插座',
      ac_connector_socket: '交流接口插座',
      ac_connector_plug: '交流接口插头',
      dc_connector_gun_head: '直流接口枪头',
      wireless_charging_stand: '无线充电座',
      other: '其他'
    },
    equipments_menu: {
      equipments_id: '编号',
      interface: '接口',
      interface_plug: '交流接口插头',
      park: '车位',
      equipment_name: '设备名',
      equipment_type: '设备类型',
      equipment_model: '型号',
      connector_name: '接口名',
      connector_id: '接口编号'
    },
    charge_detail: {
      charge_detail_info: '充电桩详情信息',
      total_power: '总功率',
      manufacturer: '厂商',
      manufacturer_organization_code: '厂商机构代码',
      model: '型号',
      date_of_production: '出厂日期',
      connector_type: '接口类型',
      voltage: '额定电压',
      electricity: '额定电流',
      power: '额定功率',
      park_number: '车位号',
      national_standard: '国家标准',
      park_status: '车位状态',
      lock_status: '地锁状态',
      qr_code: '接口二维码'
    },
    index_columns: {
      created_at: '接入时间',
      updated_at: '更新时间'
    },
    btn: {
      qrcode: '二维码导出'
    }
  }
}
